module.exports = __webpack_public_path__ + "iPhone7-Silver.png?161ca2c2768847d1ee3d60a493ef26aa";